import { useEffect, useState } from 'react';
import { Image } from 'react-bootstrap';
import { Navigate, Outlet } from 'react-router-dom';

import AppIcon from '~assets/app_icon.svg';
import { CustomIcon } from '~components/index';
import useLocalStorage from '~hooks/useLocalStorage';
import TicsocialWatermark from '~layouts/TicsocialWatermark/TicsocialWatermark';
import { ROUTES } from '~routes/routesDictionary';
import InactivityObserver from './InactivityObserver/InactivityObserver';
import Sidebar from './Sidebar/Sidebar';
import './Authenticated.scss';

const Authenticated = () => {
  const { userData } = useLocalStorage();
  const windowWidth = window.innerWidth;
  const [collapse, setCollapse] = useState(windowWidth < 1024);

  useEffect(() => {
    if (windowWidth < 1024) setCollapse(true);
  }, [location.pathname]);

  return (
    <>
      {!userData ? (
        <Navigate to={ROUTES.ROOT} />
      ) : (
        <InactivityObserver>
          <TicsocialWatermark />
          <div className="authenticated m-0 p-0">
            <div
              className={`authenticated_collapse_btn ${
                !collapse ? 'authenticated_collapse_btn_sidebar_visible' : ''
              }`}
              onClick={() => setCollapse(!collapse)}
            >
              {!collapse ? (
                <CustomIcon name="FaChevronLeft" />
              ) : (
                <Image src={AppIcon} width="30px" />
              )}
            </div>
            <div className="authenticated ">
              <Sidebar collapse={collapse} />
              <div className="authenticated_bg">
                <main className="authenticated_content">
                  <Outlet />
                </main>
              </div>
            </div>
          </div>
        </InactivityObserver>
      )}
    </>
  );
};

export default Authenticated;
